import React from 'react';
import LottieElementMenu from './LottieElementMenu/LottieElementMenu';
import { useSelectionOutline } from '@/App/remotion/MainPlayer/ClipPlayerV2WithNewTimeline/hooks/useSelectionOutline';
import CaptionsMenuV2 from '@/App/remotion/components/Captions/CaptionsMenuV2/CaptionsMenuV2';
import SpeakerLabelMenu from '@/App/remotion/components/SpeakerLabel/SpeakerLabelMenu';
import ImageElementMenu from '@/App/remotion/components/PlayerMenus/ImageElementMenu/ImageElementMenu';
import TextElementMenu from '@/App/remotion/components/ElementComponent/TextElementComponent/TextElementMenu';
import VideoElementMenu from '@/App/remotion/components/PlayerMenus/VideoElementMenu/VideoElementMenu';
import CompositeVideoElementMenu from '@/App/remotion/components/PlayerMenus/VideoElementMenu/VideoInCompositeElementMenu';
import {
  ImageOverlaySelectionElementData,
  SpeakerLabelSelectionElementData,
  TextSelectionElementData,
  VideoOverlaySelectionElementData,
  CompositeVideoSelectionElementData,
  LottieOverlaySelectionElementData
} from '@/App/remotion/components/Outlines/types';
import { SelectionElementType } from '@/player-config/src/types/RemotionPlayerConfigTypes/CompositionConfig';

function PlayerMenus() {
  const { selectedElement, selectedElementData } = useSelectionOutline();

  switch (selectedElement) {
    case SelectionElementType.CAPTIONS:
      return <CaptionsMenuV2 />;
    case SelectionElementType.SPEAKER_LABEL:
      return <SpeakerLabelMenu speakerId={(selectedElementData as SpeakerLabelSelectionElementData).speakerId} />;
    case SelectionElementType.IMAGE:
      return <ImageElementMenu imageElementId={(selectedElementData as ImageOverlaySelectionElementData).elementId} />;
    case SelectionElementType.TEXT:
      return <TextElementMenu textElementId={(selectedElementData as TextSelectionElementData).elementId} />;
    case SelectionElementType.VIDEO:
      return <VideoElementMenu videoElementId={(selectedElementData as VideoOverlaySelectionElementData).elementId} />;
    case SelectionElementType.VIDEO_IN_COMPOSITE:
      return (
        <CompositeVideoElementMenu
          cropInformation={(selectedElementData as CompositeVideoSelectionElementData).cropInformation}
          videoElementId={(selectedElementData as CompositeVideoSelectionElementData).elementId}
          videoElementRef={(selectedElementData as CompositeVideoSelectionElementData).videoElementRef}
          videoAspectRatio={(selectedElementData as CompositeVideoSelectionElementData).videoAspectRatio}
          videoUrl={(selectedElementData as CompositeVideoSelectionElementData).videoUrl ?? ''}
          compositeSegmentId={(selectedElementData as CompositeVideoSelectionElementData).compositeSegmentId}
        />
      );
    case SelectionElementType.LOTTIE:
      return (
        <LottieElementMenu lottieElementId={(selectedElementData as LottieOverlaySelectionElementData).elementId} />
      );
    default:
      return null;
  }
}

export default PlayerMenus;
